import React from 'react';
import { Box } from 'reflexbox';
import { CloseIcon, FormLabel, OpenIcon, SwitchButton } from 'boss-ui';
import { TEAM_FIELD_ACCESSIBILITY } from 'boss-ui/src/constants';
import SwitchHelpTooltip from './SwitchHelpTooltip';
import SwitchAndTooltipContainer from './SwitchAndTooltipContainer';

export default function AccessibilityToggle(props) {
  const { fieldValue, handleFieldChange } = props;
  return (
    <Box style={{ position: 'relative' }}>
      <FormLabel>Team Access</FormLabel>
      <SwitchAndTooltipContainer>
        <SwitchButton
          checked={fieldValue}
          handleToggle={handleFieldChange}
          id={TEAM_FIELD_ACCESSIBILITY}
          onIcon={<OpenIcon />}
          offIcon={<CloseIcon />}
          onText="Open"
          offText="Closed"
        />
        <SwitchHelpTooltip tooltip_id="open_question" text={
          <p>
            Open: Allow others to join the team without approval.
            <br />Closed: They must invite others to join their team.
          </p>
        } />
      </SwitchAndTooltipContainer>
    </Box>
  );
}
